import React, { useMemo } from 'react';
import { Modal, Typography, IconHighlight } from '@ann/web-components';
import { useMediaQueries } from '../../../../../utils/mediaQueries';
import { ModalBodyContent, TrainingOptionContainer, IconContainer, TextContainer } from './TrainModal.styled';

const TrainModal = ({
  isOpen,
  onClose,
  knowledgeBase,
  onUploadDocuments,
  onAIMSDrive,
  onContinueInterview,
}) => {
  const { isMobile, isIpadAirPortrait, isIpadProPortrait } = useMediaQueries();
  
  // Calculate modal width: 95% for mobile/iPad portrait, 800px otherwise
  const modalWidth = useMemo(() => {
    if (isMobile || isIpadAirPortrait || isIpadProPortrait) {
      return '95%';
    }
    return '800px';
  }, [isMobile, isIpadAirPortrait, isIpadProPortrait]);

  const knowledgeBaseName = knowledgeBase?.name || 'Knowledge Base';

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="medium" width={modalWidth}>
      <Modal.Header>
        <Modal.Header.Title>Train Facts: {knowledgeBaseName}</Modal.Header.Title>
      </Modal.Header>
      <Modal.Body>
        <ModalBodyContent>
          <Typography category="body" size="small" weight="regular" color="body">
            Select how you would like to train this knowledge base
          </Typography>
          
          <TrainingOptionContainer onClick={onUploadDocuments}>
            <IconContainer>
              <IconHighlight
                className="icon-highlight"
                bgColor="Primary"
                icon="upload"
                iconColor="PrimaryAlt"
                size="medium"
              />
            </IconContainer>
            <TextContainer>
              <Typography category="subtitle" size="medium" weight="bold">
                Upload Documents
              </Typography>
              <Typography category="body" size="medium" weight="regular" color="body">
                Upload files directly from your computer. Supports .docx, .pdf and .txt and more.
              </Typography>
            </TextContainer>
          </TrainingOptionContainer>

          <TrainingOptionContainer onClick={onAIMSDrive}>
            <IconContainer>
              <IconHighlight
                className="icon-highlight"
                bgColor="Success"
                icon="folderOpen"
                iconColor="Green"
                size="medium"
              />
            </IconContainer>
            <TextContainer>
              <Typography category="subtitle" size="medium" weight="bold">
                AIMS Drive
              </Typography>
              <Typography category="body" size="medium" weight="regular" color="body">
                Select documentos from your AIMS internal cloud storage.
              </Typography>
            </TextContainer>
          </TrainingOptionContainer>

          <TrainingOptionContainer onClick={() => onContinueInterview?.()}>
            <IconContainer>
              <IconHighlight
                className="icon-highlight"
                bgColor="Yellow"
                icon="chat_bubble"
                iconColor="Yellow"
                size="medium"
              />
            </IconContainer>
            <TextContainer>
              <Typography category="subtitle" size="medium" weight="bold">
                Continue Interview
              </Typography>
              <Typography category="body" size="medium" weight="regular" color="body">
                Hace a conversation with an AI Agent to build knowledge through Q&A.
              </Typography>
            </TextContainer>
          </TrainingOptionContainer>
        </ModalBodyContent>
      </Modal.Body>
    </Modal>
  );
};

export default TrainModal;